import React from "react";
import styled from "styled-components/macro";
import { NavLink as RouterNavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper,
} from "@mui/material";
import { spacing } from "@mui/system";
import HomeIcon from "@mui/icons-material/Home";
import { ServerDataGrid } from "../../components/CustomDataGrid";
import {
  CashCell,
  DateCell,
  DateRangeFilter,
} from "../../components/CustomCells";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const NavLink = styled(RouterNavLink)`
  display: flex;
`;

const columns = [
  {
    accessorKey: "amount",
    filterVariant: "range",
    header: "Amount",
    Cell: CashCell,
    enableHiding: false,
    operator: "betweenInclusive",
  },
  {
    accessorKey: "id",
    filterVariant: "text",
    header: "ID",
    operator: "equals",
  },
  {
    accessorKey: "depositId",
    filterVariant: "text",
    header: "Deposit ID",
    operator: "equals",
  },
  {
    accessorKey: "createdAt",
    type: "dateTime",
    header: "Create Date",
    Cell: DateCell,
    Filter: DateRangeFilter,
    operator: "betweenInclusive",
  },
];

function RefundsTable({ apiUrl }) {
  const navigate = useNavigate();

  return (
    <ServerDataGrid
      columns={columns}
      apiUrl={apiUrl}
      muiTableBodyRowProps={({ row }) => ({
        onClick: () => navigate(`/refunds/${row.original.id}`),
        sx: {
          cursor: "pointer",
        },
      })}
    />
  );
}

function RefundsGrid() {
  return (
    <React.Fragment>
      <Helmet title="Refunds" />
      <Typography variant="h3" gutterBottom display="inline">
        Refunds
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2} mb={6}>
        <Link component={NavLink} to="/">
          <HomeIcon />
        </Link>
        <Typography>Refunds</Typography>
      </Breadcrumbs>

      <Paper>
        <RefundsTable apiUrl={`/api/v1/refunds`} />
      </Paper>
    </React.Fragment>
  );
}

export default RefundsGrid;

export { RefundsTable };
